import { redirect } from 'vike/abort';

export const guard = (pageContext: any) => {
  if (pageContext.urlPathname === '/') {
    throw redirect('/pl');
  }
};
